var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.showAccountingDocument &&
                !_vm.accountingDocumentWindow.visible,
              expression:
                "!showAccountingDocument && !accountingDocumentWindow.visible"
            }
          ],
          staticClass: "grid-view"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.showAccountingDocument &&
                    !_vm.accountingDocumentWindow.visible,
                  expression:
                    "!showAccountingDocument && !accountingDocumentWindow.visible"
                }
              ],
              staticClass: "main-content accounting-document-list"
            },
            [
              _c(
                "el-form",
                { attrs: { inline: true, "label-position": "left" } },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-top": "8px" },
                      attrs: { gutter: 5, type: "flex" }
                    },
                    [
                      _c("el-col", [
                        _c(
                          "div",
                          {
                            staticClass: "app-main-inner-row operations",
                            staticStyle: {
                              padding: "0",
                              "justify-content": "flex-start"
                            }
                          },
                          [
                            _c("div", { staticClass: "triggers" }, [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { no: "1", type: "primary" },
                                      on: { click: _vm.doSearch }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Query"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "2",
                                        type: "primary",
                                        plain: ""
                                      },
                                      on: { click: _vm.doAdd }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Add"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "copy",
                                        type: "primary",
                                        plain: ""
                                      },
                                      on: { click: _vm.doCopy }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Copy"))
                                      )
                                    ]
                                  ),
                                  _vm.$checkPermission([
                                    "button_AccountingDocumentCheck"
                                  ])
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "3",
                                            disabled: !_vm.reviewBtnEnabled,
                                            type: "primary",
                                            plain: ""
                                          },
                                          on: { click: _vm.reviewHandler }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Audit")
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.$checkPermission([
                                    "button_AccountingDocumentUncheck"
                                  ])
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "4",
                                            disabled: !_vm.unreviewBtnEnabled,
                                            type: "primary",
                                            plain: ""
                                          },
                                          on: { click: _vm.unreviewHandler }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_ReverseReview"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.$checkPermission([
                                    "button_AccountingDocumnetDelete"
                                  ])
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "5",
                                            disabled: !_vm.batchDeleteBtnEnabled,
                                            type: "primary",
                                            plain: ""
                                          },
                                          on: { click: _vm.deleteClickHandler }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_BatchDelete"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "6",
                                        disabled: !_vm.batchPrintBtnEnabled,
                                        type: "primary",
                                        plain: ""
                                      },
                                      on: {
                                        click: _vm.batchExcelBtnClickHandler
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_BatchPrint")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      ]),
                      _c("el-col", [
                        _c(
                          "div",
                          {
                            staticClass: "app-main-inner-row",
                            staticStyle: { padding: "0", height: "25px" }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  right: "10px",
                                  "margin-top": "5px"
                                }
                              },
                              [
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: _vm.lbAccountType },
                                    on: { click: _vm.selectAccountSetHandler }
                                  },
                                  [_vm._v(_vm._s(_vm.lbAccount))]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-top": "12px" },
                      attrs: { gutter: 5, type: "flex" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "app-main-inner-row operations",
                          staticStyle: {
                            padding: "0",
                            "justify-content": "flex-start"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item",
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_FiscalPeriod"),
                                "label-width": "70px"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "110px" },
                                  attrs: { no: "7" },
                                  model: {
                                    value: _vm.form.fpSelect,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "fpSelect", $$v)
                                    },
                                    expression: "form.fpSelect"
                                  }
                                },
                                _vm._l(_vm.fpSelectDataProvider, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.fiscalPeriodLabelFun(item),
                                      value: item.uuid
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item",
                              staticStyle: {
                                "word-break": "break-all",
                                "white-space": "normal"
                              },
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_VoucherLetter"),
                                "label-width": "70px"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "70px" },
                                  attrs: { no: "8" },
                                  model: {
                                    value: _vm.form.prefix,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "prefix", $$v)
                                    },
                                    expression: "form.prefix"
                                  }
                                },
                                _vm._l(_vm.prefixDDL, function(item) {
                                  return _c("el-option", {
                                    key: item.name,
                                    attrs: {
                                      label: item.name,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_NumberS"),
                                "label-width": "20px"
                              }
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "80px" },
                                attrs: {
                                  no: "9",
                                  min: 0,
                                  precision: 0,
                                  controls: false
                                },
                                on: {
                                  blur: function(e) {
                                    if (e.target.value <= 0) {
                                      _vm.form.startDocumentNo = undefined
                                    }
                                  }
                                },
                                model: {
                                  value: _vm.form.startDocumentNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "startDocumentNo", $$v)
                                  },
                                  expression: "form.startDocumentNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "-", "label-width": "20px" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "80px" },
                                attrs: {
                                  no: "10",
                                  min: 0,
                                  precision: 0,
                                  controls: false
                                },
                                on: {
                                  blur: function(e) {
                                    if (e.target.value <= 0) {
                                      _vm.form.endDocumentNo = undefined
                                    }
                                  }
                                },
                                model: {
                                  value: _vm.form.endDocumentNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "endDocumentNo", $$v)
                                  },
                                  expression: "form.endDocumentNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_ProofDate"),
                                "label-width": "60px"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  no: "11",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd",
                                  editable: false
                                },
                                model: {
                                  value: _vm.form.startDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "startDate", $$v)
                                  },
                                  expression: "form.startDate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_To"),
                                "label-width": "24px"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  no: "12",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd",
                                  editable: false
                                },
                                model: {
                                  value: _vm.form.endDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "endDate", $$v)
                                  },
                                  expression: "form.endDate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_VoucherStatus"),
                                "label-width": "60px"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "80px" },
                                  attrs: { no: "13", filterable: "" },
                                  model: {
                                    value: _vm.form.state,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "state", $$v)
                                    },
                                    expression: "form.state"
                                  }
                                },
                                _vm._l(
                                  _vm.FinanceInterfaceConstants.VOUCHER_STATES2,
                                  function(item) {
                                    return _c("el-option", {
                                      key: item.code,
                                      attrs: {
                                        label:
                                          _vm.$store.getters.language === "zh"
                                            ? item.chineseName
                                            : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-top": "12px" },
                      attrs: { gutter: 5, type: "flex" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "app-main-inner-row operations",
                          staticStyle: {
                            padding: "0",
                            "justify-content": "flex-start"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                "word-break": "break-all",
                                "white-space": "normal"
                              },
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_PreparedBy"),
                                "label-width": "70px"
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  no: "14",
                                  "method-params": {
                                    officeId:
                                      _vm.$store.getters.currentOfficeId,
                                    category: "role"
                                  },
                                  "default-value": _vm.form.documentMaker || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.documentMaker = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Auditor"),
                                "label-width": "60px"
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  no: "15",
                                  "method-params": {
                                    officeId:
                                      _vm.$store.getters.currentOfficeId,
                                    category: "role"
                                  },
                                  "default-value": _vm.form.verifier || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.verifier = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_CreatedBy"),
                                "label-width": "60px"
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  no: "16",
                                  "method-params": {
                                    officeId:
                                      _vm.$store.getters.currentOfficeId,
                                    category: "role"
                                  },
                                  "default-value": _vm.form.createdBy || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.createdBy = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                "word-break": "break-all",
                                "white-space": "normal"
                              },
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_Modifier"),
                                "label-width": "60px"
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  no: "17",
                                  "method-params": {
                                    officeId:
                                      _vm.$store.getters.currentOfficeId,
                                    category: "role"
                                  },
                                  "default-value": _vm.form.modifiedBy || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.modifiedBy = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_InputTime"),
                                "label-width": "60px"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  no: "18",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd",
                                  editable: false
                                },
                                model: {
                                  value: _vm.form.dateCreatedStart,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "dateCreatedStart", $$v)
                                  },
                                  expression: "form.dateCreatedStart"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_To"),
                                "label-width": "24px"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100px" },
                                attrs: {
                                  no: "19",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd",
                                  editable: false
                                },
                                model: {
                                  value: _vm.form.dateCreatedEnd,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "dateCreatedEnd", $$v)
                                  },
                                  expression: "form.dateCreatedEnd"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { height: "800px" },
                    attrs: {
                      "config-module": "6000001",
                      "column-defs": _vm.columnDefs,
                      "grid-options": _vm.gridOptions,
                      "grid-params": _vm.girdParams,
                      "row-data": _vm.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.girdParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.girdParams = $event
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "pagination-wrapper",
                  staticStyle: { "padding-right": "0px" }
                },
                [
                  _c("cargo-pagination", {
                    attrs: {
                      "config-module": "6000000",
                      limit: _vm.page.pageSize,
                      "page-sizes": [10, 20, 30, 50, 100, 200, 500],
                      page: _vm.page.pageNum,
                      total: _vm.page.total
                    },
                    on: {
                      "update:limit": function($event) {
                        return _vm.$set(_vm.page, "pageSize", $event)
                      },
                      "update:page": function($event) {
                        return _vm.$set(_vm.page, "pageNum", $event)
                      },
                      pagination: _vm.doSearch
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.showAccountingDocument
        ? _c("accounting-document", {
            ref: "accountingDocumentWin",
            attrs: {
              "current-account-set": _vm.accountSet,
              "voucher-index": _vm.voucherIndex,
              "voucher-list": _vm.rowData,
              type: "edit"
            },
            on: {
              cancel: function($event) {
                _vm.showAccountingDocument = false
              }
            }
          })
        : _vm._e(),
      _vm.accountingDocumentWindow.visible
        ? _c("accounting-document", {
            ref: "accountingDocumentCopy",
            attrs: {
              "current-account-set": _vm.accountSet,
              "voucher-index": _vm.accountingDocumentWindow.voucherIndex,
              "voucher-list": _vm.accountingDocumentWindow.rowData,
              type: _vm.accountingDocumentWindow.type
            },
            on: { cancel: _vm.accountingDocumentCallBack }
          })
        : _vm._e(),
      _c("account-set-popup", {
        ref: "refAccountSetPopup",
        attrs: {
          mode: _vm.accountSetPopup.mode,
          visible: _vm.accountSetPopup.visible,
          "load-accounting-document-type-flag": false,
          "load-mapping-departments-flag": false,
          "load-mapping-staffs-flag": false,
          "load-accounting-documents-rule-flag": false,
          "load-current-rates-flag": true,
          "sort-fiscal-period-desc": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.accountSetPopup, "visible", $event)
          },
          cancel: function() {
            return (_vm.accountSetPopup.visible = false)
          },
          select: function(data) {
            return (_vm.accountSet = data)
          }
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          visible: _vm.templateSelectorDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }